import React, { useContext, useState } from 'react'
import { Handle } from 'react-flow-renderer'
import { NodesContext } from '../provider/IvrContext'
import WebhookSelectModal from '../Helpers/WebhookSelectModal'
import { toast } from 'react-toastify'

const AnswerNode = ({ data, id }) => {
    const { nodeConnections, webhookList, smsWebhookList, updateNodeData } = useContext(NodesContext)
    const outgoingCount = nodeConnections?.["new-target-handle"]?.length ?? 0
    const disabled = outgoingCount >= 1;
    const [webhookModalOpen, setWebhookModalOpen] = useState(false);
    const webhookConfig = data?.webhookConfig || null;

    const saveWebhookConfig = (cfg) => {
        updateNodeData(id, { webhookConfig: cfg });
        toast.success(cfg ? "Webhook saved." : "Webhook cleared.");
    };

    return (
        <div
            className="ivr-flow-node"
            style={{
                width: "75px",
                height: "55px",
                border: "2px solid green",
                background: "#fff",
                position: "relative",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {/* Handle */}
            <Handle
                type="source"
                position="bottom"
                id="new-target-handle"
                style={{
                    position: "absolute",
                    backgroundColor: "green",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    bottom: "-4px",
                    left: "50%",
                    transform: "translateX(-50%)",
                }}
                isConnectable={!disabled}
            />

            {/* Node Label */}
            <div
                className="ivr-flow-node-label"
                style={{
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "#333",
                    textAlign: "center",
                    textTransform: "capitalize",
                }}
            >
                {data.label}
            </div>

            <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
                <i
                    className="fa fa-link ivr-flow-node-icon"
                    style={{
                        color: webhookConfig ? "green" : "#888",
                        fontSize: 12,
                        cursor: "pointer",
                    }}
                    title="Webhook"
                    onClick={() => setWebhookModalOpen(true)}
                />
            </div>

            <WebhookSelectModal
                show={webhookModalOpen}
                onClose={() => setWebhookModalOpen(false)}
                value={webhookConfig}
                onSave={saveWebhookConfig}
                webhookList={webhookList}
                smsWebhookList={smsWebhookList}
                title="Answer Node Webhook"
            />
        </div>
    )
}

export default AnswerNode
